import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=3d1c2c7a&scoped=true"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"
import style0 from "./Info.vue?vue&type=style&index=0&id=3d1c2c7a&prod&scoped=true&lang=less"
import style1 from "./Info.vue?vue&type=style&index=1&id=3d1c2c7a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1c2c7a",
  null
  
)

export default component.exports